export const FormatProductTitle = title => {
  return title.split(/\s-\s(.*)/g);
};
